export default "__VITE_ASSET__CSAMx4iU__"